import MuiTab from '@mui/material/Tab';
import { NavLink } from 'react-router-dom';

export default function Tab({
  hidden = false,
  label,
  value,
}: {
  hidden?: boolean;
  label: string;
  value: string;
}) {
  if (hidden) {
    return null;
  }

  return <MuiTab component={NavLink} label={label} to={value} value={value} />;
}
